// 菜单配置
// headerMenuConfig：头部导航配置
// asideMenuConfig：侧边导航配置
import { formatMessage } from '@/i18n';
import { isELC, getElctype, isLite } from '@/tool/profile';

import Auths from './auth/Auths';

const getHeaderMenuConfig = () => {
  return [
    // {
    //   name: '反馈',
    //   path: 'https://baidu.com',
    //   external: true,
    //   newWindow: true,
    //   icon: 'message',
    // },
    // {
    //   name: '帮助',
    //   path: 'https://baidu.com',
    //   external: true,
    //   newWindow: true,
    //   icon: 'bangzhu',
    //   hideMobile: false,
    //   hasPopup: false,
    // },
    {
      name: formatMessage('menu.readdata'),
      path: '/record/lock/reader',
      external: false,
      newWindow: false,
      icon: 'creative',
      hideMobile: true,
      hasPopup: false,
      authority: Auths.readRECORD,
    },
    // {
    //   name: formatMessage('menu.patrol.record.upload'),
    //   path: '/patrol/records/upload',
    //   external: false,
    //   newWindow: false,
    //   icon: 'publish',
    //   hideMobile: true,
    //   hasPopup: false,
    //   authority: Auths.uploadPATROL_RECORD,
    // },
  ];
};

const asideMenuConfig = [
  {
    name: () => formatMessage('menu.company'),
    path: '/company',
    icon: 'home2',
    authority: Auths.ADMINISTRATOR,
  },
  {
    name: () => formatMessage('menu.systemsettings'),
    path: '/settings',
    icon: 'shezhi',
    authority: Auths.ADMINISTRATOR,
  },
  {
    name: () => formatMessage('menu.dashboard'),
    path: '/',
    icon: 'home2',
    // 后台返回约定的虚拟权限
    authority: Auths.DASHBOARD,
  },
  // {
  //   name: '钥匙盒（调试）',
  //   path: '/keybox',
  //   icon: 'directory',
  // },
  {
    name: () => formatMessage('menu.basic'),
    path: '/basic',
    icon: 'anchor',
    children: [
      {
        name: () => formatMessage('menu.basic.dept'),
        path: '/basic/dept',
        authority: Auths.queryDEPT,
      },
      // {
      //   name: () => formatMessage('menu.basic.worker'),
      //   path: '/basic/worker',
      //   authority: Auths.queryWORKER,
      // },
      {
        name: () => formatMessage('menu.basic.user'),
        path: '/basic/user',
        authority: Auths.queryUSER,
      },
      {
        name: () => formatMessage('menu.basic.role'),
        path: '/basic/role',
        authority: Auths.queryROLE,
      },
    ],
  },
  // 机柜管理
  {
    name: () => {
      return formatMessage(`menu.elccabinet${isELC() && getElctype() === 1 ? '.pds' : ''}`);
    },
    path: '/elccabinet',
    icon: 'align-flex',
    children: [
      {
        name: () => {
          return formatMessage(
            `menu.elccabinet${isELC() && getElctype() === 1 ? '.pds' : ''}.list`
          );
        },
        path: '/elccabinet/list',
        authority: Auths.queryELCCABINET,
      },
    ],
  }, // 控制器管理
  {
    name: () => formatMessage('menu.elccontroller'),
    path: '/elccontroller',
    icon: 'cascades',
    children: [
      {
        name: () => formatMessage('menu.elccontroller.list'),
        path: '/elccontroller/list',
        authority: Auths.queryELCCONTROLLER,
      },
    ],
  },
  //  钥匙柜管理
  {
    name: () => formatMessage('menu.keycabinet'),
    path: '/cabinet',
    icon: {
      dark: require('@/images/cabinet.png'),
      light: require('@/images/cabinet_light.png'),
    },
    children: [
      {
        name: () => formatMessage('menu.keycabinet.list'),
        path: '/cabinet/list',
        authority: Auths.queryKEYCABINET,
      },
      {
        name: () => formatMessage('menu.keycabinet.hole.list'),
        path: '/cabinet/hole/list',
        authority: Auths.queryKEYCABINETNODE,
      },
    ],
  },
  //  钥匙盒管理
  {
    name: () => formatMessage('menu.keybox'),
    path: '/box',
    icon: 'directory',
    children: [
      {
        name: () => formatMessage('menu.keybox.list'),
        path: '/box/list',
        authority: Auths.queryKEYBOX,
      },
      {
        name: () => formatMessage('menu.keybox.cabinet.list'),
        path: '/box/hole/list',
        authority: Auths.queryKEYBOXNODE,
      },
    ],
  },
  {
    name: () => formatMessage('menu.key'),
    path: '/key',
    icon: 'key',
    children: [
      {
        name: () => formatMessage('menu.key.list'),
        path: '/key/list',
        authority: Auths.queryKEY,
      },
      {
        name: () => formatMessage('menu.key.add'),
        path: '/key/edit',
        // TODO: 如果只有设置权限，而没有查询权限，添加后会跳转到钥匙列表界面，报403，需不需要处理一下？
        authority: Auths.addKEY,
      },
      // {
      //   name: () => formatMessage('menu.key.params'),
      //   path: '/key/params',
      //   authority: Auths.setKeyParam,
      // },
      {
        name: () => formatMessage('menu.key.out'),
        path: '/key/out',
        authority: Auths.outKEY,
      },
      {
        name: () => formatMessage('menu.key.blacklist'),
        path: '/key/blacklist',
        authority: Auths.queryBLACKLIST,
      },
    ],
  },
  {
    name: () => {
      if (isELC()) {
        return formatMessage('menu.elc.lock');
      }
      return formatMessage('menu.lock');
    },
    path: '/lock',
    icon: 'lock',
    children: [
      {
        name: () => formatMessage('menu.lock.list'),
        path: '/lock/list',
        authority: Auths.queryLOCK,
      },
      {
        name: () => formatMessage('menu.lock.add'),
        path: '/lock/edit',
        // TODO: 如果只有设置权限，而没有查询权限，添加后会跳转到锁列表界面，报403错误，需不需要处理一下？
        authority: Auths.addLOCK,
      },
    ],
  },
  {
    name: () => formatMessage('menu.task'),
    path: '/task',
    icon: 'task',
    children: [
      {
        name: () => formatMessage('menu.task.list'),
        path: '/task/list',
        authority: Auths.queryTASK,
      },
      {
        name: () => formatMessage('menu.task.add'),
        path: '/task/edit',
        authority: Auths.addTASK,
      },
      // {
      //   name: () => formatMessage('menu.task.updating'),
      //   path: '/task/updating',
      //   authority: Auths.queryTASKUPDATING,
      // },
    ],
  },
  {
    name: () => formatMessage('menu.patrol'),
    path: '/patrol',
    icon: 'compass',
    children: [
      {
        name: () => formatMessage('menu.patrol.site'),
        path: '/patrol/site',
        authority: Auths.queryPATROL_SITE,
      },
      {
        name: () => formatMessage('menu.patrol.content'),
        path: '/patrol/content',
        authority: Auths.queryPATROL_CONTENT,
      },
      {
        name: () => formatMessage('menu.patrol.plan'),
        path: '/patrol/plan',
        authority: Auths.queryPATROL_PLAN,
      },
      {
        name: () => formatMessage('menu.patrol.record'),
        path: '/patrol/records',
        authority: Auths.queryPATROL_RECORD,
      },
      {
        name: () => formatMessage('menu.patrol.report'),
        path: '/patrol/report',
        authority: Auths.queryPATROL_REPORT,
      },
    ],
  },
  {
    name: () => formatMessage('menu.record'),
    path: '/record',
    icon: 'eye',
    children: [
      {
        name: () => formatMessage('menu.keybox.log.list'),
        path: '/record/operatelog/list',
        authority: Auths.queryKEYBOX_DATA,
      },
      {
        name: () => formatMessage('menu.record.key.outin'),
        path: '/record/key/outin',
        authority: Auths.queryKEY_OUTIN,
      },
      {
        name: () => {
          if (isLite()) {
            return formatMessage('menu.record.task.authority');
          }
          return formatMessage('menu.record.task.download');
        },
        path: '/record/task/download',
        authority: Auths.queryTASK_DOWNLOAD,
      },
      {
        name: () => {
          if (isELC()) {
            return formatMessage('menu.record.emergency.switch');
          }
          return formatMessage('menu.record.lock.switch');
        },
        path: '/record/lock/switch',
        authority: Auths.queryLOCK_SWITCH,
      },
      {
        name: () => formatMessage('menu.record.lock.eventdata'),
        path: '/record/lock/eventdata',
        authority: Auths.queryLOCK_EVENTDATA,
      },
      {
        name: () => formatMessage('menu.record.elccabinetdoor.switch'),
        path: '/record/elccabinetdoor/switch',
        authority: Auths.queryELCDOOR_SWITCH,
      },
      {
        name: () => formatMessage('menu.record.elcalarm'),
        path: '/record/elcalarm',
        authority: Auths.queryELCALARM_DATA,
      },
      {
        name: () => formatMessage('menu.record.key.lost'),
        path: '/record/key/lost',
        authority: Auths.queryKEY_LOST,
      },
      {
        name: () => formatMessage('menu.record.lock.replace'),
        path: '/record/lock/replace',
        authority: Auths.queryLOCK_REPLACE,
      },
      {
        name: () => formatMessage('menu.record.log'),
        path: '/record/log',
        authority: Auths.queryLOG,
      },
    ],
  },
];

export { getHeaderMenuConfig, asideMenuConfig };
